import React, { type ComponentProps } from 'react';

import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import { PageSegmentLoadStart } from '@confluence/browser-metrics/entry-points/PageSegmentLoadStart.ts';

import { GLOBAL_NAVIGATION_METRIC } from './perf.config.ts';

const GlobalNavigationLoader: LoadableType<{
	productSideNavigation?: React.ReactNode;
	isOnAnySettingsScreen?: boolean;
	isCollapsed?: boolean;
}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-GlobalNavigation" */ './GlobalNavigationComponent.tsx'
			)
		).GlobalNavigationComponent,
});

export const GlobalNavigation = (props: GlobalNavigationProps): React.JSX.Element => (
	<>
		<PageSegmentLoadStart metric={GLOBAL_NAVIGATION_METRIC} />
		<GlobalNavigationLoader {...props} />
	</>
);

type GlobalNavigationProps = ComponentProps<typeof GlobalNavigationLoader>;
